(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["sim88-quantity-presets"] && !Shopify.designMode) return;
  try {
    (() => {
    const readNumber = (value, fallback) => {
      const parsed = Number(value);
      return Number.isFinite(parsed) ? parsed : fallback;
    };

    const initialize = (root) => {
      if (root.dataset.sim88QuantityPresetsReady === 'true') return;
      const container = root.closest('[id^="Quantity-Form-"]');
      const input = container?.querySelector('input.quantity__input[name="quantity"]');
      if (!input) return;
      root.dataset.sim88QuantityPresetsReady = 'true';

      const buttons = [...root.querySelectorAll('[data-quantity]')];
      const normalized = (requested) => {
        const min = readNumber(input.min, 1);
        const max = input.max === '' ? Infinity : readNumber(input.max, Infinity);
        const step = Math.max(1, readNumber(input.step, 1));
        const clamped = Math.min(max, Math.max(min, requested));
        return min + Math.round((clamped - min) / step) * step;
      };
      const sync = () => {
        const current = readNumber(input.value, normalized(1));
        const min = readNumber(input.min, 1);
        const max = input.max === '' ? Infinity : readNumber(input.max, Infinity);
        const step = Math.max(1, readNumber(input.step, 1));
        for (const button of buttons) {
          const requested = readNumber(button.dataset.quantity, 1);
          const valid = requested >= min && requested <= max && (requested - min) % step === 0;
          button.disabled = !valid;
          button.setAttribute('aria-pressed', String(valid && current === requested));
        }
      };

      root.addEventListener('click', (event) => {
        const button = event.target.closest('[data-quantity]');
        if (!button || button.disabled) return;
        input.value = String(normalized(readNumber(button.dataset.quantity, 1)));
        input.dispatchEvent(new Event('input', { bubbles: true }));
        input.dispatchEvent(new Event('change', { bubbles: true }));
        sync();
      });
      input.addEventListener('input', sync);
      input.addEventListener('change', sync);
      new MutationObserver(sync).observe(input, { attributes: true, attributeFilter: ['min', 'max', 'step'] });
      sync();
    };

    const initializeWithin = (scope) => {
      scope.querySelectorAll('[data-sim88-quantity-presets]').forEach(initialize);
    };

    initializeWithin(document);
    document.addEventListener('shopify:section:load', (event) => initializeWithin(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
